import React, { useEffect } from "react";
import { Card, Container, Div, Text } from "../../styles/Common";
import { theme } from "../../styles/theme";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useParams } from "react-router-dom";
import { Link } from "../../components/Link";
import back from "../../assets/icons/arrow-left.svg";
import { Button } from "../../components/Button";
import { Skeleton } from "../../components/Skeleton";
import { Table } from "../../components/Table";
import documentIcon from "../../assets/icons/document.svg";
import { ModalDocument } from "./components/ModalDocuments";
import { useState } from "react";
import useGetQualificationList from "./hooks/useGetQualificationList";
import useGetCertificationList from "./hooks/useGetCertificationList";
import { dateFormat } from "../../utilities/helpers";

const ApplicationUsersInfo = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.sm})`,
  });
  const { userId } = useParams();
  const [openModal, setOpenModal] = useState(false);
  const [documentTypeName, setDocumentTypeName] = useState("");
  const { data: qualificationList, isSuccess: isSuccessQualificationList } = useGetQualificationList(userId);
  const { data: certificationList, isSuccess: isSuccessCertificationList } = useGetCertificationList(userId);
  const [qualificationsData, setQualificationsData] = useState([]);
  const [certificationsData, setCertificationsData] = useState([]);

  const handleBack = () => {
    navigate(`/application`);
  };

  const handleViewDocument = (documentId, documentTypeId) => {
    navigate(`/application/user-info/${userId}/document-detail/${documentId}?docTypeId=${documentTypeId}`);
  };

  useEffect(() => {
    if (isSuccessQualificationList) {
      setQualificationsData(qualificationList?.data);
    }
  }, [isSuccessQualificationList]);
  
  useEffect(() => {
    if (isSuccessCertificationList) {
      setCertificationsData(certificationList?.data);
    }
  }, [isSuccessCertificationList]);

  const addQualificationDocument = () => {
    setOpenModal(true);
    setDocumentTypeName("Qualification");
  };

  const addCertificationDocument = () => {
    setOpenModal(true);
    setDocumentTypeName("Certification");
  };

  const qualificationsColumns = [
    {
      title: "Qualification",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Qualification Number",
      dataIndex: "number",
      key: "number",
      align: "center",
    },
    {
      title: "Expiration Date",
      dataIndex: "expirationDate",
      key: "expirationDate",
      align: "center",
      render: (text) => text ? dateFormat(text) : "-",
    },
    {
      title: "Document",
      dataIndex: "document",
      key: "document",
      align: "center",
      render: (text, item) => (
        <Div align="center" justify="center" gap="12px">
          <img 
            alt="document" 
            src={documentIcon} 
            onClick={() => handleViewDocument(item.documentId, item.documentTypeId)}
            style={{ cursor: "pointer" }}
          />
        </Div>
      ),
    }
  ];

  const certificationsColumns = [
    {
      title: "Equipment",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Serial Number",
      dataIndex: "serialNumber",
      key: "serialNumber",
      align: "center",
    },
    {
      title: "Range",
      dataIndex: "range",
      key: "range",
      align: "center",
    },
    {
      title: "Expiration Date",
      dataIndex: "expirationDate",
      key: "expirationDate",
      align: "center",
      render: (text) => text ? dateFormat(text) : "-",
    },
    {
      title: "Document",
      dataIndex: "document",
      key: "document",
      align: "center",
      render: (text, item) => (
        <Div align="center" justify="center" gap="12px">
          <img 
            alt="document" 
            src={documentIcon} 
            onClick={() => handleViewDocument(item.documentId, item.documentTypeId)}
            style={{ cursor: "pointer" }}
          />
        </Div>
      ),
    },
  ];

  return (
    <Container>
      <ModalDocument
        openModal={openModal}
        setOpenModal={setOpenModal}
        id={userId}
        documentTypeName={documentTypeName}
        setDocumentTypeName={setDocumentTypeName}
      />
      <Div m="0 0 25px 0" height="30px" align="center">
        <Link
          onClick={handleBack}
          color={theme.colors.grey1}
          icon={<img alt="back" src={back} style={{ marginRight: "12px" }} />}
        >
          Back
        </Link>
      </Div>
      <Div width="100%" height="55px">
        <Text
          size={isMobile ? theme.fonts.size.h6 : theme.fonts.size.h4}
          color={theme.colors.dark}
          weight={theme.fonts.weight.bold}
        >
          User Info
        </Text>
      </Div>
      <Div direction="column" gap="32px" width="100%">
        <Card padding="32px 31px 35px 30px" style={{ flexDirection: "column" }}>
          <Div 
            width="100%" 
            direction={isMobile ? "column" : "row"} 
            justify={isMobile ? "start" : "space-between"} 
            gap={isMobile ? "16px" : "0"} 
            align={isMobile ? "flex-start" : "center"}
          >
            <Text color={theme.colors.dark} weight={theme.fonts.weight.bold} size={theme.fonts.size.h6}>
              Qualifications
            </Text>
            <Button 
              border={theme.colors.dark2} 
              color={theme.colors.dark} 
              width="233px" 
              height="35px" 
              onClick={addQualificationDocument}
            >
              Add Qualification
            </Button>
          </Div>
          <Div m="32px 0 0 0" width="100%" style={{ overflowX: "auto" }}>
            <Table
              columns={qualificationsColumns}
              data={qualificationsData}
              rowClassName={(record, index) =>
                index % 2 === 0 ? "table-row-light" : "table-row-dark"
              }
              sizerLabels={["Show", "Results"]}
              pagination={false}
              locale={{
                emptyText:
                  false ? (
                    <Div justify="center" gap="16px">
                      {[...Array(9)].map((v, idx) => (
                        <Skeleton
                          title={false}
                          paragraph={{
                            rows: 10,
                            width: "100%",
                          }}
                          loading
                          key={idx}
                        />
                      ))}
                    </Div>
                  ) : (
                    "No data"
                  ),
              }}
              scroll={isMobile ? { x: "max-content" } : undefined}
            />
          </Div>
        </Card>
        <Card padding="32px 31px 35px 30px" style={{ flexDirection: "column" }}>
          <Div 
            width="100%" 
            direction={isMobile ? "column" : "row"} 
            justify={isMobile ? "start" : "space-between"} 
            gap={isMobile ? "16px" : "0"} 
            align={isMobile ? "flex-start" : "center"}
          >
            <Text color={theme.colors.dark} weight={theme.fonts.weight.bold} size={theme.fonts.size.h6}>
              Certification
            </Text>
            <Button 
              border={theme.colors.dark2} 
              color={theme.colors.dark} 
              width="233px" 
              height="35px" 
              onClick={addCertificationDocument}
            >
              Add Certification
            </Button>
          </Div>
          <Div m="32px 0 0 0" width="100%" style={{ overflowX: "auto" }}>
            <Table
              columns={certificationsColumns}
              data={certificationsData}
              rowClassName={(record, index) =>
                index % 2 === 0 ? "table-row-light" : "table-row-dark"
              }
              sizerLabels={["Show", "Results"]}
              pagination={false}
              locale={{
                emptyText:
                  false ? (
                    <Div justify="center" gap="16px">
                      {[...Array(9)].map((v, idx) => (
                        <Skeleton
                          title={false}
                          paragraph={{
                            rows: 10,
                            width: "100%",
                          }}
                          loading
                          key={idx}
                        />
                      ))}
                    </Div>
                  ) : (
                    "No data"
                  ),
              }}
              scroll={isMobile ? { x: "max-content" } : undefined}
            />
          </Div>
        </Card>
      </Div>
    </Container>
  );
};

export default ApplicationUsersInfo;